// extracted by mini-css-extract-plugin
module.exports = {"slider":"ProductSliderBlock_slider__w8Znr","productSlider":"ProductSliderBlock_productSlider__B9DHD"};